
import $ from 'jquery';
import Vue from 'vue';
import { Component, Inject } from 'vue-property-decorator';
import { initClient } from '../../../api';
import { PqtMeasurementSpecificationTemplate, PqtMeasurementSpecificationTemplatesUiV2Client } from '../../backend/backendapi';
import State from '../State';
import Spinner from '../../util/Spinner';

@Component({
  components: { Spinner },
})
export default class MeasurementSpecificationTemplateDeleteModal extends Vue {
  @Inject()
  readonly state!: State;

  private readonly api = initClient(PqtMeasurementSpecificationTemplatesUiV2Client);

  deleting = false;
  templates: PqtMeasurementSpecificationTemplate[] = [];

  public open(templates: PqtMeasurementSpecificationTemplate[]): void {
    this.templates = templates;
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }

  async deleteSelected(): Promise<void> {
    if (!this.templates.length) {
      return;
    }

    this.deleting = true;
    try {
      let deleted = 0;
      for (let template of this.templates) {
        try {
          await this.api.delete(template.id);
          this.state.templatesStore.forgetTemplate(template);
        } catch (e) {
          this.$toasted.error(this.$t('txtError') + ': ' + JSON.stringify(e));
        }
      }
      if (deleted > 0) {
        this.$toasted.info(this.$t('txtDeleted').toString());
      }
      this.$emit('deleted');
      this.dismiss();
    } finally {
      this.deleting = false;
    }
  }
}
